export default {
	suggestions: {
		senderFirstName: "Sender First Name",
		senderLastName: "Sender Last Name",
		unsubscribe_link: "Unsubscribe Link",
	},
};
